import React from 'react';

export interface IProps {
  fillColor?: string;
}

const ThreeQuartersStarIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="46" height="49" viewBox="0 0 46 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 1.71376L27.6856 17.075L27.7936 17.4291H28.1638L43.4113 17.4291L31.0492 26.9964L30.7763 27.2076L30.877 27.5377L35.5823 42.9637L23.306 33.4628L23 33.2259L22.694 33.4628L10.4177 42.9637L15.123 27.5377L15.2237 27.2076L14.9508 26.9964L2.5887 17.4291L17.8362 17.4291H18.2064L18.3144 17.075L23 1.71376Z" stroke={props.fillColor ?? "#FFD84D"}/>
        <path d="M22.8743 0L27.5 16.9291V36.5L22.875 32.5L22.8743 33.8582L9.35524 44.3209L14.5191 27.3918L1 16.9291L17.7105 16.9291L22.8743 0Z" fill={props.fillColor ?? "#FFD84D"}/>
    </svg>
  )
}

export default ThreeQuartersStarIcon;